import React, { FC } from 'react';
import { useRouteMatch } from 'react-router-dom';
import Styled from './style';

type IProps = {
	title: string;
	link: string;
	img: string;
};

const NavTab: FC<IProps> = ({ title, link, img }) => {
	let match = useRouteMatch({
		path: link,
		exact: true,
	});

	const image = require(`../../assets/images/${
		match ? img + '-active' : img
	}.png`).default;

	return (
		<Styled.StyledNavLink
			exact
			to={link}
			match={match}
			img={img}
		>
			<Styled.Img src={image} />
			<Styled.Title
				text={title}
				color={match ? 'sapphirine' : 'navText'}
				size="large"
			/>
		</Styled.StyledNavLink>
	);
};

export default NavTab;
